import { OptionValue } from '../dto/OptionValue';
import { TenantDto } from '../dto/TenantDto';
import Envoy from '../util/Envoy';

class TenantProvider extends Envoy {
  public async getAll(): Promise<Array<TenantDto>> {
    try {
      const response = await this.conn.get('/tenant');
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));

      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter todos os locatários:', error);
      throw error;
    }
  }

  public async getAllOptions(): Promise<Array<OptionValue>> {
    try {
      const response = await this.conn.get('/tenant/options');
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));

      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter todos os locatários:', error);
      throw error;
    }
  }

  public async getFromLoggedUser(): Promise<Array<OptionValue>> {
    try {
      const response = await this.conn.get('/tenant/user/options');
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));
      
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter as opções do usuário:', error);
      throw error;
    }
  }

  public async create(tenant: TenantDto): Promise<TenantDto> {
    try {
      const response = await this.conn.post('/tenant', tenant);
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));

      return response.data.data;
    } catch (error) {
      console.log({error})
      console.error('Erro ao criar locatário:', error);
      throw error;
    }
  }

  public async getById(id: number): Promise<TenantDto> {
    try {
      const response = await this.conn.get(`/tenant/${id}`);
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));

      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter locatário:', error);
      throw error;
    }
  }

  public async update(id: number, tenantDetails: TenantDto): Promise<TenantDto> {
    try {
      const response = await this.conn.put(`/tenant/${id}`, tenantDetails);
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));

      return response.data.data;
    } catch (error) {
      console.error('Erro ao atualizar locatário:', error);
      throw error;
    }
  }

  public async delete(id: number): Promise<void> {
    try {
      const response = await this.conn.delete(`/tenant/${id}`);
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));
    } catch (error) {
      console.error('Erro ao excluir locatário:', error);
      throw error;
    }
  }

  public async deactivate(id: number): Promise<void> {
    try {
      const response = await this.conn.put(`/tenant/deactivate/${id}`);
      
      if (response.data.messages && response.data.messages.length)
        throw new Error(response.data.messages.join('\n'));
    } catch (error) {
      console.error('Erro ao desativar locatário:', error);
      throw error;
    }
  }
}

export default TenantProvider;